<template>
  <div class="challenge-weeks mt-4">
    <p><strong>Challenge Weeks</strong></p>
    <div v-for="(challenge_week, index) in form.challenge_weeks" class="d-flex w-100 align-items-center justify-content-between">
      <button v-if="form.challenge_weeks.length > 1" @click="removeChallengeWeek(index)" type="button" class="btn btn-link text-danger"><i class="fa fa-times"></i></button>
      <div class="w-100">
        <div class="form-group flex-grow-1 ml-3">
          <label for="week-start">Week Start</label>
          <FormDatepicker id="week-start" v-model="form.challenge_weeks[index].week_start" :name="`challenge_weeks[${index}][week_start]`"/>
        </div>
        <div class="form-group flex-grow-1 ml-3">
          <label for="week-end">Week End</label>
          <FormDatepicker id="week-end" v-model="form.challenge_weeks[index].week_end" :name="`challenge_weeks[${index}][week_end]`"/>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button @click="addChallengeWeek" type="button" class="btn btn-outline">Add Challenge Week</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import FormDatepicker from '../form/FormDatepicker';

const DEFAULT = {
  challenge_weeks: []
};

export default {
  components: {
    FormDatepicker
  },
  props: {
    weeks: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: DEFAULT
    }
  },
  mounted() {
    if (this.weeks.length) {
      this.weeks.forEach(week => {
        this.form.challenge_weeks.push({
          week_start: moment(week.week_start).format('M/D/YYYY'),
          week_end: moment(week.week_end).format('M/D/YYYY')
        })
      });
    } else {
      this.form.challenge_weeks = [{
        week_start: '',
        week_end: '',
      }];
    }
  },
  methods: {
    addChallengeWeek() {
      this.form.challenge_weeks.push({
        week_start: '',
        week_end: '',
      });
    },
    removeChallengeWeek(index) {
      this.form.challenge_weeks.splice(index, 1);
    }
  }
}
</script>